export default __webpack_public_path__ + "static/home_projects-36f32ea1e437b566d790bbc7a3c15916.webp";